var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { Container, CssBaseline, Divider, Grid } from '@material-ui/core';
import { ProductImage } from '../../../organisms/ProductImage';
import { Description } from '../../../organisms/Description';
import { useCommonStyles } from '../AvailableTemplate';
import { BarcodeImage } from '../../../organisms/BarcodeImage';
import { CouponName } from '../../../organisms/CouponName';
/**
 * パターン５。店舗名サイズ拡大。
 */
export var BigShopNameTemplate = function (props) {
    var classes = useCommonStyles();
    return (React.createElement(Container, { disableGutters: true },
        React.createElement(CssBaseline, null),
        React.createElement(Grid, { container: true, direction: "row", justifyContent: "center", alignItems: "center" },
            React.createElement(Grid, { item: true, xs: 12, className: classes.section }, props.companyImageUrl ? (React.createElement("img", { src: props.companyImageUrl, className: classes.image, alt: props.organizationName.companyName })) : (React.createElement(React.Fragment, null))),
            React.createElement(Grid, { item: true, xs: 12, className: classes.section },
                React.createElement(CouponName, __assign({}, props.couponName))),
            React.createElement(Grid, { item: true, xs: 12, className: classes.section },
                React.createElement(BarcodeImage, __assign({}, props.barcode))),
            props.productImage ? (React.createElement(Grid, { item: true, xs: 12, className: classes.section },
                React.createElement(ProductImage, __assign({}, props.productImage)))) : (React.createElement(React.Fragment, null))),
        React.createElement(Divider, { variant: "fullWidth" }),
        React.createElement(Description, __assign({}, props.description))));
};
//# sourceMappingURL=BigShopNameTemplate.js.map